/*
 * Copyright (c) 2020 Honeywell International, Inc. All rights reserved.
 *
 * This file contains trade secrets of Honeywell International, Inc.  No part
 *  may be reproduced or transmitted in any form by any means or for any
 *  purpose without the express written permission of Honeywell.
 *
 */
import React, { Component, Fragment, useState } from "react";
import "./GatewayRegFailedSummary.scss";
import Error from "../../../icons/Error.svg";
import { Button } from "@scuf/common";
import {
  IFCPDIYGatewayManagementProps,
  IAxiosError,
} from "../../../stores/GatewayManager/IGatewayRegistrationInterfaces";
import { IGatewayDetails} from "../../gateway/registration/IGatewayDetails"
import { inject, observer } from "mobx-react";
import { GatewayRegSetup } from "./GatewayRegistrationSetup";
import FCDIYGatewayRegistration from "../../gateway/registration/FCDIYGatewayRegistration";
import { UserManager } from "@forge/sso-client";

export interface IConfirmGatewaySelectionProps
  extends IFCPDIYGatewayManagementProps {
  gatewayDetails:IGatewayDetails;
  axiosError: IAxiosError;
}

export const GatewayRegistrationFailedSummary = (
  props: IConfirmGatewaySelectionProps
) => {
  const [renderView, setRenderView] = useState(false);

  const retry = () => {
    return (
      <div>
        {renderView ? (
          <FCDIYGatewayRegistration 
          appliance =  {props.gatewayDetails.appliance}
          details = {props.gatewayDetails.details}
          userInfo = {props.gatewayDetails.userInfo}         
        ></FCDIYGatewayRegistration>
        ) : (
          ""
        )}
      </div>
    );
  };

  const logout = () => {
    UserManager.getInstance().signoutRedirect();
  };

  const contactSupport = () => {
    let envVariables = props.globalStore!.envVariables;
    let emailAdress = envVariables.FCP_SUPPORT_EMAIL_ID;
    return `mailto: ${emailAdress}?subject=Gateway registration has failed.`;
  };

  const showFailSummary = () => {
    return (
      <Fragment>
        <div>
          <div className="summary application-page-content ui-gateway-res-container">
            <div className="ui-gateway-selection-title">Setup Failed</div>
            <img src={Error} className="ui-summary-icon" />
            <div className="ui-res-summary">
              <div>
                <div>Gateway registration has failed.</div>
                <div>{props.axiosError.message}</div>
                <div className="ui-res-contact-admin">
                  Please contact support or retry after sometime.
                </div>
              </div>
              <div className="ui-result-contact-summary">
                <div>
                  For further queries,{" "}
                  <a href={contactSupport()}>Contact Support.</a>
                </div>
              </div>
            </div>
          </div>
          <div className="application-navigation ui-box-shadow">
            <div className="ui-site-selection-navigation">
              <Button
                className="ui-gateway-confirmation-button-logout"
                type="primary"
                size="small"
                content="Logout"
                onClick={() => {
                  logout();
                }}
              />
              <Button
                className="ui-gateway-confirmation-button-retry"
                type="secondary"
                size="small"
                content="Retry"
                onClick={() => {
                  setRenderView(true);
                }}
              />
            </div>
          </div>
        </div>
      </Fragment>
    );
  };

  return <Fragment>{renderView ? retry() : showFailSummary()}</Fragment>;
};
export const GatewayRegFailedSummary = inject("globalStore")(
  GatewayRegistrationFailedSummary
);
